import React, { useState } from "react";
import { upload_document, upload_document_v2 } from "./CompanyObjectChanges";
import FormButtom from "../../../../../components/common/forms/FormButtom";
import ReusableNewCompany from "../common/ReusableNewCompany";
import Documents from "../../../../../components/common/forms/Documents";
import { useForm } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";
import FormNewPayment from "../../../../../components/common/forms/FormNewPayment";
import FormBranch from "../../../../../components/common/forms/FormBranch";
import api from "../../../../../api/api";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import AdminSearchCustomer from "../../../common/AdminSearchCustomer";
import NewFormPayment from "../../../../../components/common/forms/NewFormPayment";

const NewCmpObj = () => {
  const { register, handleSubmit } = useForm();
  const [docsOutput, setDocsOutput] = useState();
  const [uploadProof, setUploadProof] = useState('')

  const { user, isSuccess } = useSelector((state) => state.auth);
  const [userID, setUserId] = useState(null)
  

  const handleSub = (data) => {
    data.documents = docsOutput;
    if(user?.user_type === "CL"){
      const user = JSON.parse(localStorage.getItem("user"));
      data.user = user.user_id;
    }else {
        if(userID !== null){
          data.user = userID
        }
    } 
  
    api
      .post(`services/company/`, data)
      .then((response) => {
        toast.success("Data Registered Successfully")
        
        // let transactions = {
        //   // payment_mode: "e_wallet",
        //   amount: 2500,
        //   service_object_id: response.data.registration_id,
        //   created_by: response.data.registration_id,
        //   service_object_content_type: response.data.service_content_type_id,
        //   payment_proof : uploadProof,
        //   company : response.data.company_id,
        //   transaction_type: "credit"
       
        // };

        
        // api
        // .post("/transactions/", transactions)
        // .then((response) => {
        //   toast.success("Data Registered 2 Successfully.");
        // })
        // .catch((error) => {
        //   toast.error("Error in Transaction");
        // });

      })
      .catch((error) => {
        // console.log("error", error);
        toast.error("Something went wrong")
      });




  };

  let data_v2 = [];
  upload_document_v2.map((item, i) => {
    data_v2.push({ id: uuidv4(), image: "", document_name: "" });
    return "";
  });

  return (
    <form>
       <div className="mt-3">
          {

           (user?.user_type === "ST" || user?.user_type === "AD")
            && <AdminSearchCustomer 
             setUserId={setUserId}
            /> 
          }
         </div>
      <ReusableNewCompany register={register} />

      {/*note closed */}
      {/* new company for 3 months close */}

      <div className=" border-primary-blue mt-3">
        <div className="flex items-center text-primary-blue mt-0 font-semibold leading-10 text-center">
          <p className=" text-primary-blue  text-lg">2. Upload Document{" "} <span className="font-Laila">माथी ३ महिने विवरण पेश गर्नको लागि आवश्यक पर्ने निम्न कागजपत्रहरु  </span>{" "} <span className=" text-primary-red px-2 underline">Upload</span> गर्नुहोस ।
          </p></div>
      </div>
      {/* upload documents open */}

      {/* <table>
      <thead>
        <tr>
          <td className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
            S. N.
          </td>
          <td className="border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
            Document Name
          </td>
          <td className="border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
            Action
          </td>
          <td className="border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
            Remarks
          </td>
        </tr>
      </thead>
      <tbody>
        {upload_document_v2.map((item, index) => {
          return (
            <tr className="border-primary-blue border">
              <td className="text-primary-red border-primary-blue border-r px-10 text-center font-semibold">
                {item.sn}
              </td>
              <td className="p-0">
                <p className="border-primary-blue text-primary-blue font-semibold m-0 h-[54px] w-full border-r py-3 px-3 outline-none">
                  {item.ip1}
                  <button className="bg-primary-blue text-white rounded-xl ml-3 px-2">
                    Upload
                  </button>
                </p>
              </td>
              <td className="p-0">
                <div className="border-primary-blue text-white m-0 h-[54px] w-full border-r py-3 px-3 outline-none space-x-2">
                  <button className="bg-primary-green rounded-xl px-2 ">
                    view
                  </button>
                  <button className="bg-primary-red rounded-xl px-2">
                    Delete
                  </button>
                </div>
              </td>
              <td className="p-0">
                <div className="border-primary-blue text-primary-blue font-semibold m-0 h-[54px] w-full border-r py-3 px-3 outline-none space-x-2">
                  {item.remark}
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table> */}
      {/* upload documents close */}

      <Documents
        documents_data={upload_document_v2}
        initialState={data_v2}
        setDocument={setDocsOutput}
      />
          <div className="text-primary-blue font-Calistoga text-lg my-5 mb-6 underline">
              3. Working Branch
              <span className="text-primary-blue underline font-Laila mx-2 ">
                (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन शाखा नजिक पर्छ छनोट गर्नुहोस् ।)
              </span>
            </div>

     <FormBranch register={register}/>


    {/* open modal */}
      <FormButtom/>
      
      <NewFormPayment handleSubmit={handleSubmit} handleClick={handleSub} 
       setUploadProof={setUploadProof}
      />
    </form>
  );
};

export default NewCmpObj;
